// extracted by mini-css-extract-plugin
export default {"container":"discounts_container__e+RTa","discount_list":"discounts_discount_list__zXTBy"};